import React, { ReactElement } from "react";

import { Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import BasicSelector from "../../../../components/Redux/BasicSelector";
import StringMapInput from "../../../../components/Redux/StringMapInput";
import Switch from "../../../../components/Redux/Switch";
import SettingSection from "../../../../components/SettingSection";
import useFeatureFlag from "../../../../hooks/use-feature-flag";
import {
  getSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import { SectionProps } from "../../../routes/components/edit_sections/common";
import { BearerTokenFormatOptions } from "../BearerTokenFormatOptions";

export const Headers = ({
  readonly,
  tabValue,
  refresh,
}: SectionProps): ReactElement => {
  const idpTokensEnabled = useFeatureFlag("idp-tokens", false);
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          Headers
        </Typography>
        <Divider />
        <SettingSection
          label="Pass Identity Headers"
          docsKey="pass-identity-headers"
        >
          <Switch
            path="passIdentityHeaders"
            label=""
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
          />
        </SettingSection>
        <Divider />

        <SettingSection label="JWT Claim Headers" docsKey="jwt-claim-headers">
          <StringMapInput
            readonly={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            path={"jwtClaimsHeaders"}
          />
        </SettingSection>
        <Divider />

        <SettingSection
          label="X-Forwarded-For HTTP Header"
          docsKey="x-forwarded-for-http-header"
        >
          <Switch
            path="skipXffAppend"
            label=""
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
          />
        </SettingSection>
        <Divider />

        <SettingSection label="Response Headers" docsKey="response-headers">
          <StringMapInput
            readonly={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            path={"setResponseHeaders"}
          />
        </SettingSection>

        {idpTokensEnabled && (
          <>
            <Divider />
            <SettingSection
              label="Bearer Token Format"
              docsKey="bearer-token-format"
            >
              <BasicSelector
                path="bearerTokenFormat"
                options={BearerTokenFormatOptions}
                setter={setSettingsFormProperty}
                getter={getSettingsFormProperty}
                errorHandler={setSettingsFormError}
                readonly={readonly}
              />
            </SettingSection>
          </>
        )}
      </Stack>
    </Container>
  );
};
